function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.911 17.715h-8.84c-2.523 0-4.568-2.049-4.568-4.576V5.287C.503 2.76 2.548.712 5.071.712h8.84c2.523 0 4.569 2.048 4.569 4.575v7.852c0 2.527-2.046 4.576-4.569 4.576zm3.07-10.292h-3.495c-1.148 0-2.082.741-2.082 1.65v.28c0 .91.934 1.65 2.082 1.65h3.495v-3.58zm0 5.081h-3.495c-1.974 0-3.58-1.414-3.58-3.151v-.28c0-1.737 1.606-3.15 3.58-3.15h3.495v-.636c0-1.696-1.377-3.075-3.07-3.075h-8.84c-1.693 0-3.07 1.379-3.07 3.075v7.852c0 1.696 1.377 3.075 3.07 3.075h8.84c1.693 0 3.07-1.379 3.07-3.075v-.635zM7.988 6.355H4.556c-.431 0-.781-.35-.781-.782 0-.431.35-.782.781-.782h3.432c.431 0 .781.351.781.782 0 .432-.35.782-.781.782zm5.244 2.858c0-.276.224-.5.5-.5h1.623c.275 0 .499.224.499.5s-.224.5-.499.5h-1.623c-.276 0-.5-.224-.5-.5z"
});

var SvgMyWallet = function SvgMyWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my_wallet.f28d9559.svg";
export { ForwardRef as ReactComponent };